import React, { Component } from 'react';
import {Image} from 'react-bootstrap';
import "./recorder.css";
import config from '../../config/config';


class Recorder extends Component {

    URL_ERROR = 'v-6b14da28-0f9d-487e-b7bb-79833e022f23';

    constructor(props) {
        super(props);
        this.state = {
            cameraTagInstance: null,
            scriptsLoaded: false,
            cameraTagId: this.props.id || `camera-tag-${(new Date()).getTime()}`,
            error: false,
            countError: 0,
            widthCamera: 0,
        };

        this.cameraEventHandler = this.cameraEventHandler.bind(this);
        this.handleCameraTagError = this.handleCameraTagError.bind(this);
        this.initCamera = this.initCamera.bind(this);
    }

    componentDidMount() {
        let widthCamera = window.innerWidth - 30;
        if (widthCamera > 1140) {
            widthCamera = 1140;
        }
        this.setState({
            widthCamera,
        });

        const script = document.createElement('script');
        script.src = config.camera_tag_src_library;
        script.async = false;
        script.onload = this.initCamera;
        script.onerror = (error) => { this.handleCameraTagError(error) };
        document.body.appendChild(script);

        this.errorTimer = setInterval(function () {
            const element = document.getElementsByClassName('cameratag_error');
            if (element.length && element[0].style.display !== 'none') {
                const error = element[0].innerHTML;
                this.handleCameraTagError(error);
            }
        }.bind(this), 1500);

        if (parseInt(config.force_show_camera_next_button)) {
            this.props.setImage(this.URL_ERROR);
        }
    }

    componentWillUnmount() {
        clearInterval(this.errorTimer);
    }

    async handleCameraTagError(error) {
        const auxCount = this.state.countError + 1;
        if (this.state.cameraTagInstance) {
            this.state.cameraTagInstance.destroy();
        }
        if (auxCount > 1) {
            clearInterval(this.errorTimer);
            this.props.setImage(this.URL_ERROR);
            this.setState({
                countError: auxCount,
            });
            this.props.setError(true);
        } else {
            await this.setState({
                cameraTagInstance: null,
                cameraTagId: this.props.id || `camera-tag-${(new Date()).getTime()}`,
                countError: auxCount,
            });
            this.initCamera();
        }
    }

    initCamera() {
        try {
            console.log('inicializando camara');
            const CameraTag = window.CameraTag || null;
            CameraTag.setup();
            if (CameraTag && CameraTag.setup) {
                CameraTag.setup();
                CameraTag.observe(this.state.cameraTagId, 'initialized', () => {
                    this.setState({
                        cameraTagInstance: CameraTag.cameras[this.state.cameraTagId]
                    });
                    this.cameraEventHandler('initialized');
                });
                CameraTag.observe(this.state.cameraTagId, 'publishing', () => {
                    this.cameraEventHandler('publishing');
                });
                CameraTag.observe(this.state.cameraTagId, 'published', () => {
                    this.cameraEventHandler('published');
                });
                CameraTag.observe(this.state.cameraTagId, 'serverError', () => {
                    this.cameraEventHandler('serverError');
                });
                CameraTag.observe(this.state.cameraTagId, 'noMic', () => {
                    this.cameraEventHandler('noMic');
                });
                CameraTag.observe(this.state.cameraTagId, 'uploadAborted', () => {
                    this.cameraEventHandler('uploadAborted');
                });
                CameraTag.observe(this.state.cameraTagId, 'publishFailed', () => {
                    this.cameraEventHandler('publishFailed');
                });
                CameraTag.observe(this.state.cameraTagId, 'processingFailed', () => {
                    this.cameraEventHandler('processingFailed');
                });
                this.setState({
                    scriptsLoaded: true,
                });
            } else {
                console.log('No se ha alcanzado a cargar setup');
                setTimeout(this.initCamera, 500);
            }
        } catch (error) {
            console.log('No se ha alcanzado a cargar setup', error);
            setTimeout(this.initCamera, 500);
        }
    }

    cameraEventHandler(event) {
        switch (event) {
            case 'initialized':
                break;
            case 'publishing':
                break;
            case 'published':
                try {
                    if (this.state.cameraTagInstance) {
                        const myVideo = this.state.cameraTagInstance.getVideo();
                        this.props.setImage(myVideo.uuid);
                        this.props.nextStep();
                    } else {
                        throw new Error("Error to get camera");
                    }
                } catch (error) {
                    this.handleCameraTagError(error);
                }
                break;
            case 'serverError':
                this.handleCameraTagError('serverError');
                break;
            case 'noMic':
                this.handleCameraTagError('noMic');
                break;
            case 'uploadAborted':
                this.handleCameraTagError('uploadAborted');
                break;
            case 'publishFailed':
                this.handleCameraTagError('publishFailed');
                break;
            case 'processingFailed':
                this.handleCameraTagError('processingFailed');
                break;
            default:
                break;
        }
    }

    render() {
        const icon = require('../../resources/images/cameraRecord.svg').default;
        if (this.state.scriptsLoaded) {
            return (
                <div>
                    {config.upload_video_test === 'false' &&
                        <>
                        <camera
                            id={this.state.cameraTagId}
                            data-app-id={config.camera_tag_id}
                            data-sources='record,sms'
                            data-maxlength={config.camera_tag_record_seconds}
                            data-minlength='1'
                            data-upload-on-select='false'
                            data-width={`${this.state.widthCamera}px`}
                            ref={this.camera}
                            className='camera'
                        />
                        <div id={`${this.state.cameraTagId}-start-screen`}>
                            <a className={'cameratag_record custom-start-record'}>
                                <div className="image">
                                    <Image src={icon} />
                                </div>
                                <p>Presione para iniciar la grabación desde la camara</p>
                            </a>
                        </div>
                        </>
                        
                    }
                    {(this.state.countError === 1 || config.upload_video_test === 'true') &&
                        <div>
                            <p>Por favor inténtalo nuevamente.</p>
                            <p>Si tienes problemas para grabar, puedes cargar un video desde tu celular</p>
                            <camera
                                id={this.state.cameraTagId}
                                data-app-id={config.camera_tag_id}
                                data-sources='record,sms,upload'
                                data-maxlength={config.camera_tag_record_seconds}
                                data-minlength='1'
                                data-upload-on-select='true'
                                data-width={`${this.state.widthCamera}px`}
                                ref={this.camera}
                                className='camera'
                                data-stack='mediarecorder'
                            />
                        </div>
                    }
                </div>
            );
        }
        else {
            return (
                <div>
                    Cargando Grabador de video...
                </div>
            );
        }
    }

}
export default Recorder;
